<template>
  <right-panel :datas="connects" @onClose="onClose" ref="right-panel">
    <div slot="header">
      <translate>Setting Team Group</translate>
    </div>
    <div slot="content" class="wrapper-padding">
      <el-form :model="setting" :rules="rules" ref="groupForm" label-width="110px">
        <el-form-item :label="attrText.name" prop="name">
           <el-input v-model.trim="setting.name"></el-input>
        </el-form-item>
        <el-form-item :label="attrText.note" prop="note">
          <!-- <el-input v-model.trim="setting.note"></el-input> -->
          <el-input type="textarea" class="right-panel-textarea" v-model.trim="setting.note"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="detail-btn">
      <el-button type="primary" @click="onSubmitForm()" :disabled="!setting.isCanSubmit">
        <translate>Save</translate>
      </el-button>
      <el-button @click="$refs['right-panel'].onClose()">
        <translate>Cancel</translate>
      </el-button>
    </div>
  </right-panel>
</template>

<script>
  import STORE_CONST from '../../../store/consts'
  import RightPanel from '../../common/right-panel'
  export default{
    name: 'TeamGroupSetting',
    props: {
      items: {
        required: true
      }
    },
    data () {
      return {
        connects: null,
        setting: {
          name: '',
          note: '',
          isCanSubmit: false
        },
        rules: {
          name: [
            {required: true, message: this.$gettext('Please input the group name'), trigger: 'blur, change'},
            {max: 20, message: this.$gettext('length is within 20 characters'), trigger: 'change'}
          ],
          note: [
            {max: 140, message: this.$gettext('length is within 140 characters'), trigger: 'change'}
          ]
        }
      }
    },
    computed: {
      attrText () {
        return this.getTranslateText()
      }
    },
    created () {
    },
    methods: {
      // 给seting赋值
      setVal (connects) {
        this.setting.name = connects.name
        this.setting.note = connects.note
      },
      // 提取翻译文本
      getTranslateText () {
        return {
          name: this.$gettext('Group Name'),
          note: this.$gettext('Comment')
        }
      },
      // 提交修改
      onSubmitForm () {
        this.$refs['groupForm'].validate((valid) => {
          if (valid) {
            let params = {
              group_id: this.connects.id,
              data: {
                data: {
                }
              }
            }
            if (this.setting.name !== this.connects.name) {
              params.data.data.name = this.setting.name
            }
            if (this.setting.note !== this.connects.note) {
              params.data.data.note = this.setting.note
            }
            this.$store.dispatch(STORE_CONST.TEAM.EDIT_GROUP, params).then(() => {
              this.$notify({
                type: 'success',
                message: this.$gettext('Change successfully!')
              })
              this.$emit('callback')
            })
            this.$refs['right-panel'].onClose()
          } else {
            return false
          }
        })
      },
      // 关闭创建集群
      onClose () {
        this.connects = null
        this.$emit('onClosePanel')
      }
    },
    watch: {
      'items': {
        handler: function (newVal) {
          console.log('---this.items---', this.items)
          if (this.connects) {
            this.connects = null
            setTimeout(() => {
              this.connects = this.items
              this.setVal(this.connects)
            }, 300)
          } else {
            this.connects = this.items
            this.setVal(this.connects)
          }
        },
        deep: true
      },
      'setting': {
        handler: function (val) {
          if (this.connects && (this.setting.name !== this.connects.name || this.setting.note !== this.connects.note)) {
            this.setting.isCanSubmit = true
          } else {
            this.setting.isCanSubmit = false
          }
        },
        deep: true
      }
    },
    components: {
      RightPanel
    }
  }
</script>

<style lang='scss' rel="stylesheet/scss">

</style>



// WEBPACK FOOTER //
// team-group-setting.vue?2c20964c